import type { TenantBrandTheme } from "../../core/types.ts";

export const zuuTenantBase = {
  primary: "#103365",
  secondary: "#E1E6EC",
  tertiary: "#F0F5FA",
  shadowColor: "rgba(16,51,101,0.3)",
  accent: "#B6985A",
  gradientStart: "#2E4D78",
  gradientEnd: "#103365",
  fontFamily: `NotoSans, "Noto Sans", sans-serif`,
  tabsActive: {
    background: "#103365",
    borderColor: "#103365",
    color: "#ffffff",
    shadow: "0px 1px 6px 0px rgba(222,227,234,0.6)",
  },
  radii: {
    sm: 6,
    md: 8,
    lg: 10,
    xl: 12,
    full: 9999,
  },
} satisfies TenantBrandTheme;
